var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2852_4909",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4935 14.1608C12.7881 13.8075 13.3143 13.7599 13.6678 14.0542L14.9235 15.1015C15.2767 15.3962 15.3245 15.9216 15.0301 16.2751C14.7355 16.6283 14.2101 16.676 13.8566 16.3817L12.6001 15.3351C12.2469 15.0404 12.199 14.5143 12.4935 14.1608ZM8.59942 4.59781C8.84225 4.37241 9.19583 4.31173 9.4995 4.444C9.80325 4.57647 9.99992 4.87676 10 5.20816V14.7915C10 15.1229 9.80333 15.4232 9.4995 15.5557C9.19575 15.6879 8.84225 15.6273 8.59942 15.4018L5.92285 12.9165H4.16667C3.24619 12.9165 2.5 12.1703 2.5 11.2498V8.74985C2.50007 7.8294 3.24623 7.08316 4.16667 7.08316H5.92285L8.59942 4.59781ZM15.8333 9.16651C16.2934 9.16668 16.6666 9.53976 16.6667 9.99985C16.6666 10.4599 16.2934 10.833 15.8333 10.8332H14.1667C13.7066 10.833 13.3334 10.4599 13.3333 9.99985C13.3334 9.53976 13.7066 9.16668 14.1667 9.16651H15.8333ZM13.8566 3.61799C14.2101 3.32371 14.7355 3.3714 15.0301 3.7246C15.3245 4.07811 15.2768 4.60431 14.9235 4.89891L13.6678 5.94546C13.3143 6.2398 12.7881 6.19215 12.4935 5.83885C12.1991 5.48551 12.2472 4.96008 12.6001 4.66535L13.8566 3.61799Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2852_4909)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.d5e9429546050e181af7f5c8ed9fa743.svg";
export { ForwardRef as ReactComponent };